import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Styles from './RolePermissionList.module.css'
import { IFText, RolesPermissionsListItem } from 'Components'
import { useTranslation } from 'react-i18next'
import { Scrollbars } from 'react-custom-scrollbars'
import { connect } from 'react-redux'
import RoleSelectors from 'Stores/Role/Selectors'
import { formatPermissionName } from 'Utils/permissionFunctions'
import adminPermissions from 'Enums/permissions'
import { permissionKey } from '../../Utils/permissionFunctions'

const RolePermissionList = ({
  role = null,
  isEditing = false,
  onPermissionsChange = () => {},
  resetPermissions = false,
  titleFontSize = '16px',
  titleFontWeight = 'normal',
  rolesWithAdmins,
  height = 508,
}) => {
  const { t } = useTranslation()
  const [selectedPermissions, setSelectedPermissions] = useState([])

  const getInitialPermissions = (r) => {
    const updatedRole = rolesWithAdmins.find((ro) => ro._id === r._id) || r
    return updatedRole.permissions.map(permissionKey)
  }

  useEffect(() => {
    if (role) setSelectedPermissions(getInitialPermissions(role))
    else setSelectedPermissions([])
  }, [role])

  useEffect(() => {
    const permissionObjects = selectedPermissions.map((key) => {
      const [action, subject] = key.split(':')
      return { action, subject }
    })
    onPermissionsChange(permissionObjects)
  }, [selectedPermissions])

  useEffect(() => {
    if (resetPermissions) {
      if (role) setSelectedPermissions(getInitialPermissions(role))
      else setSelectedPermissions([])
    }
  }, [resetPermissions, role])

  const togglePermission = (perm) => {
    const key = permissionKey(perm)
    setSelectedPermissions((prev) =>
      prev.includes(key) ? prev.filter((p) => p !== key) : [...prev, key],
    )
  }

  return (
    <div>
      <IFText style={{ fontSize: titleFontSize, fontWeight: titleFontWeight }}>
        {t('RoleDetails.Permissions')}
      </IFText>
      <Scrollbars
        className={Styles.PermissionContainerDiv}
        style={{ height: height }}
      >
        <div className={Styles.PermissionContainerDiv}>
          {adminPermissions.map((perm) => {
            const isChecked = selectedPermissions.includes(permissionKey(perm))
            return (
              <RolesPermissionsListItem
                key={permissionKey(perm)}
                title={formatPermissionName(perm.action, perm.subject)}
                isSelected={isChecked}
                isEditing={isEditing}
                onToggle={() => togglePermission(perm)}
              />
            )
          })}
        </div>
      </Scrollbars>
    </div>
  )
}

const mapStateToProps = (state) => ({
  rolesWithAdmins: RoleSelectors.getRolesWithAdmins(state),
})

RolePermissionList.propTypes = {
  role: PropTypes.object,
  isEditing: PropTypes.bool,
  onPermissionsChange: PropTypes.func,
  resetPermissions: PropTypes.bool,
  titleFontSize: PropTypes.string,
  titleFontWeight: PropTypes.string,
  rolesWithAdmins: PropTypes.array,
}

export default connect(mapStateToProps)(RolePermissionList)
